import {PageLink} from '../../../../../_metronic/layout/core'
import {ShareholdersTypes} from '../../stakeholders-and-investors/core/_constants'

export const FounderAndPromoterBreadcrum: Array<PageLink> = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

export const AddFounderAndPromoterBreadcrum: Array<PageLink> = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Founders and Promoters',
    path: 'stakeholders/founders-and-promoters',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

export const FounderAndPromoterDetailsBreadcrum: Array<PageLink> = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Founders and Promoters',
    path: 'stakeholders/founders-and-promoters',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

export enum FounderPromoterTypes {
  FOUNDER = 'founder',
  PROMOTER = 'promoter',
  FOUNDER_PROMOTER = 'founder-promoter',
}

export const FounderPromoterOptions = [
  {id: 1, label: 'Founder', value: 'founder'},
  {id: 2, label: 'Promoter', value: 'promoter'},
  {id: 3, label: 'Founder & Promoter', value: 'founder-promoter'},
]

export const stakeholdersTypeOptions = [
  {id: 1, label: 'Institution', value: ShareholdersTypes.INSTITUTIONAL},
  {id: 2, label: 'Individual', value: ShareholdersTypes.INDIVIDUAL},
]

export const convertibleSecurityClassesRateOptions = [
  {id: 1, label: '0% to 10%', value: '0_10'},
  {id: 2, label: '10% to 20%', value: '10_20'},
  {id: 3, label: '20% to 30%', value: '20_30'},
  {id: 4, label: '30% and Above', value: '30_above'},
]

export const activityLogFilterOptions = [
  {id: 1, label: 'MOVED', value: 'moved'},
  {id: 2, label: 'EDITED', value: 'edited'},
  {id: 3, label: 'SHARED', value: 'shared'},
  {id: 4, label: 'RENAMED', value: 'renamed'},
  {id: 5, label: 'VIEWED', value: 'viewed'},
]

export const securityPermissionOptions = [
  {id: 1, label: 'Admin', value: 'admin'},
  {id: 2, label: 'Billing Manager', value: 'billing'},
  {id: 3, label: 'Investor Curator', value: 'curator'},
  {id: 4, label: 'Fund Raise Manager', value: 'frm'},
  {id: 5, label: 'Investor Relationship Manager', value: 'irm'},
  {id: 6, label: 'Super Admin (Owner)', value: 'owner'},
]

export const urgencyOptions = [
  {id: 1, label: 'HIGH', value: 'HIGH'},
  {id: 2, label: 'MEDIUM', value: 'MEDIUM'},
  {id: 3, label: 'LOW', value: 'LOW'},
]

export const actionOptions = [
  {id: 1, label: 'REQUESTED', value: 'REQUESTED'},
  {id: 2, label: 'REJECTED', value: 'REJECTED'},
  {id: 3, label: 'UPLOADED', value: 'UPLOADED'},
]

export const reportOptions = [
  {id: 1, label: 'Access Report', value: 'Access Report'},
  {id: 2, label: 'Edit Report', value: 'Edit Report'},
  {id: 3, label: 'Modification Report', value: 'Modification Report'},
  {id: 4, label: 'Deletion Report', value: 'Deletion Report'},
  {id: 5, label: 'Upload Report', value: 'Upload Report'},
]

export const frequencyOptions = [
  {id: 1, label: 'Daily', value: 'Daily'},
  {id: 2, label: 'Weekly', value: 'Weekly'},
  {id: 3, label: 'Monthly', value: 'Monthly'},
  {id: 4, label: 'Yearly', value: 'Yearly'},
]
